export enum UserRole {
    Admin = "admin",
    CSM = "csm", 
    TAM = "tam", 
  }
  